export default "__VITE_PUBLIC_ASSET__85b6ae0f__"